export interface AvatarConfig {
  id: string;
  src: string;
  label: string;
}

export const avatarConfig: AvatarConfig[] = [
  { id: "avatar1", src: "/images/avatars/avatar1.svg", label: "Avatar 1" },
  { id: "avatar2", src: "/images/avatars/avatar2.svg", label: "Avatar 2" },
  { id: "avatar3", src: "/images/avatars/avatar3.svg", label: "Avatar 3" },
  { id: "avatar4", src: "/images/avatars/avatar4.svg", label: "Avatar 4" },
  { id: "avatar5", src: "/images/avatars/avatar5.svg", label: "Avatar 5" },
  { id: "avatar6", src: "/images/avatars/avatar6.svg", label: "Avatar 6" },
  { id: "avatar7", src: "/images/avatars/avatar7.svg", label: "Avatar 7" },
  { id: "avatar8", src: "/images/avatars/avatar8.svg", label: "Avatar 8" },
  { id: "avatar9", src: "/images/avatars/avatar9.svg", label: "Avatar 9" },
  { id: "avatar10", src: "/images/avatars/avatar10.svg", label: "Avatar 10" },
  { id: "avatar11", src: "/images/avatars/avatar11.svg", label: "Avatar 11" },
  { id: "avatar12", src: "/images/avatars/avatar12.svg", label: "Avatar 12" },
  { id: "avatar13", src: "/images/avatars/avatar13.svg", label: "Avatar 13" },
  { id: "avatar14", src: "/images/avatars/avatar14.svg", label: "Avatar 14" },
  { id: "avatar15", src: "/images/avatars/avatar15.svg", label: "Avatar 15" },
  { id: "avatar16", src: "/images/avatars/avatar16.svg", label: "Avatar 16" },
];

export const getAvatars = () => avatarConfig;

export const getAvatarById = (id: string | null) =>
  id ? avatarConfig.find((avatar) => avatar.id === id)?.src : null;
